class BrandsSlider extends HTMLElement {
  constructor() {
    super();
    
    this.marquees = this.querySelectorAll('[data-css-marquee]');
    this.speed = this.getAttribute('data-speed');

    if (this.marquees.length > 0) {
      this.initBrandsSlider();
    }
  }
  
  initBrandsSlider() {
    // Read widths before any DOM mutation to avoid forced reflow
    const widths = new Map();
    this.marquees.forEach(marquee => {
      marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
        widths.set(list, list.offsetWidth);
      });
    });

    // Duplicate each [data-css-marquee-list] element inside its container
    this.marquees.forEach(marquee => {
      marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
        const duplicate = list.cloneNode(true);
        marquee.appendChild(duplicate);
      });
    });

    // Create an IntersectionObserver to check if the marquee container is in view
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.querySelectorAll('[data-css-marquee-list]').forEach(list =>
          list.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused'
        );
      });
    }, { threshold: 0 });

    // Apply animation duration using pre-read widths (no reflow)
    this.marquees.forEach(marquee => {
      marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
        const w = widths.get(list) ?? list.offsetWidth;
        list.style.animationDuration = (w / this.speed) + 's';
        list.style.animationPlayState = 'paused';
      });
      observer.observe(marquee);
    });

    // Make marquee stop on hover
    this.marquees.forEach(marquee => {
      marquee.addEventListener('mouseenter', () => {
        marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
          list.style.animationPlayState = 'paused';
        });
      });
      marquee.addEventListener('mouseleave', () => {
        marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
          list.style.animationPlayState = 'running';
        });
      });
    });
  }
}

customElements.define('brands-slider', BrandsSlider); 